export function calculateRentPrice(rentPriceItemDetails, startedAt, endedAt, chargeRate, platformCommissionRate) {
    // console.log("요금표 상세 데이터:", rentPriceItemDetails);
    // console.log("시작일:", startedAt);
    // console.log("종료일:", endedAt);
    // console.log("청구율:", chargeRate);

    if (endedAt <= startedAt) {
        throw new Error("반납일은 대여일 날짜보다 빠를 수 없습니다.");
    }

    const totalMinutes = (endedAt - startedAt) / (1000 * 60); // 밀리초 -> 분 변환
    const days = Math.floor(totalMinutes / (24 * 60));
    const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
    const minutes = totalMinutes % 60;

    console.log(`days [${days}] hours [${hours}] minutes [${minutes}]`);

    // 구간별 요금표에서 해당 구간의 고정 요금 찾기
    const filtered = rentPriceItemDetails.filter((item) => item.startHour <= days * 24 + hours && item.endHour > days * 24 + hours);

    if (filtered.length === 0) {
        // console.error("적용된 요금표 없음:", rentPriceItemDetails);
        throw new Error("대여시간에 맞는 요금표를 찾을 수 없습니다.");
    }

    const basePrice = filtered[0].price;
    console.log(`기준요금 [${Math.floor(basePrice)}]`);
    const chargeRateDecimal = chargeRate / 100;
    const rentFee = (basePrice * days + basePrice * (hours / 24)) * chargeRateDecimal;

    const insuranceChargeFee = rentFee; // 이미 청구율이 적용된 값이므로 중복 적용하지 않음
    const platformCommissionFee = getPercentValue(insuranceChargeFee, platformCommissionRate);
    const exceptCommissionFee = insuranceChargeFee - platformCommissionFee;
    const exceptAddTaxFee = exceptCommissionFee / 1.1;
    const orderCommissionFee = getPercentValue(exceptAddTaxFee, 15.0);
    const obtainEarningFee = exceptAddTaxFee - orderCommissionFee;
    const chargeFee = insuranceChargeFee;

    console.log(`총 대여료 [${Math.floor(rentFee)}]`);
    console.log(`보험사 청구금 [${Math.floor(insuranceChargeFee)}]`);
    console.log(`플랫폼 수수료 [${Math.floor(platformCommissionFee)}]`);
    console.log(`수수료 제외수익 [${Math.floor(exceptCommissionFee)}]`);
    console.log(`부가세 제외금액 [${Math.floor(exceptAddTaxFee)}]`);
    console.log(`오더업체 수수료 [${Math.floor(orderCommissionFee)}]`);
    console.log(`렌트카 수익 [${Math.floor(obtainEarningFee)}]`);

    return {
        rentFee: Math.floor(rentFee),
        insuranceChargeFee: Math.floor(insuranceChargeFee),
        platformCommissionFee: Math.floor(platformCommissionFee),
        exceptCommissionFee: Math.floor(exceptCommissionFee),
        exceptAddTaxFee: Math.floor(exceptAddTaxFee),
        orderCommissionFee: Math.floor(orderCommissionFee),
        obtainEarningFee: Math.floor(obtainEarningFee),
        chargeFee: Math.floor(chargeFee),
    };
}

function getPercentValue(amount, percent) {
    return (amount * percent) / 100;
}

// contractGroup 전체 대여기간(일, 시간, 분) 합산 함수
export function sumRentalDurations(contracts) {
    let totalMinutes = 0;
    contracts.forEach((contract) => {
        if (contract.allocation?.releasedAt && contract.allocation?.returnedAt) {
            const start = new Date(contract.allocation.releasedAt);
            const end = new Date(contract.allocation.returnedAt);
            totalMinutes += (end - start) / (1000 * 60);
        }
    });
    const days = Math.floor(totalMinutes / (24 * 60));
    const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
    return { days, hours, totalMinutes };
}

// groupBasePrice(기준요금)으로 요금 계산
export function calculateRentPriceWithGroupBasePrice(groupBasePrice, days, hours, chargeRate, platformCommissionRate, baseDivideHours) {
    const rentFee = (groupBasePrice * days + groupBasePrice * (hours / baseDivideHours)) * (chargeRate / 100);
    const insuranceChargeFee = rentFee;
    const platformCommissionFee = getPercentValue(insuranceChargeFee, platformCommissionRate);
    const exceptCommissionFee = insuranceChargeFee - platformCommissionFee;
    const exceptAddTaxFee = exceptCommissionFee / 1.1;
    const orderCommissionFee = getPercentValue(exceptAddTaxFee, 15.0);
    const obtainEarningFee = exceptAddTaxFee - orderCommissionFee;
    const chargeFee = insuranceChargeFee;
    return {
        rentFee: Math.floor(rentFee),
        insuranceChargeFee: Math.floor(insuranceChargeFee),
        platformCommissionFee: Math.floor(platformCommissionFee),
        exceptCommissionFee: Math.floor(exceptCommissionFee),
        exceptAddTaxFee: Math.floor(exceptAddTaxFee),
        orderCommissionFee: Math.floor(orderCommissionFee),
        obtainEarningFee: Math.floor(obtainEarningFee),
        chargeFee: Math.floor(chargeFee),
    };
}
